(ns teamoesterreich.admin-mode.data.webSelection
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]

            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))




(defn create-first-list [owner-tom-id done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/web-user-selection")
                   (ajax/serialize {:webUserSelection-active     true
                                    :webUserSelection-name       (str "Auswahl " owner-tom-id)
                                    :webUserSelection-ownerTomId owner-tom-id})
                   (fn [r-list status]
                     (log/debug "create-first-list done" r-list status)
                     (when (= status 200)
                       (done-fn
                         (into {} (map (fn [e] [(get e "webUserSelection-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                         )))))

(defn >create-list [owner-tom-id name done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/web-user-selection")
                   (ajax/serialize {:webUserSelection-active     true
                                    :webUserSelection-name       name
                                    :webUserSelection-ownerTomId owner-tom-id})
                   (fn [r-list status]
                     (log/debug "create-list done" name r-list status)
                     (when (and (>= status 200) (< status 400))
                       (done-fn
                         (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))))))

(defn >drop-list [uuid done-fn]
  (ajax/auth-delete> (backend/get-auth) (str backend/BASE_URL "/web-user-selection/" uuid)
                     (fn [r-list status]
                       (log/debug "drop-list done" r-list status)
                       (when (< status 400)
                         (done-fn)))))

(defn get-selections [owner-tom-id done-fn]
  (when owner-tom-id
    (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/web-user-selection/for-owner/" owner-tom-id)
                    (fn [r-list status]
                      (log/debug "get-webSelection done" r-list status)
                      (when (= status 200)
                        (done-fn
                          (into {} (map (fn [e] [(get e "webUserSelection-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                          ))))))

(defn get-user [uuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/web-user-selection/" uuid)
                  (fn [r-list status]
                    (log/debug "get-webSelectionUSer done" r-list status)
                    (when (= status 200)
                      (done-fn
                        (into {} (map (fn [e] [(get e "user-tomId") (clojure.walk/keywordize-keys e)]) (get (js->clj (json/parse r-list)) "webUserSelection-user")))
                        )))))

(defn >add-user [uuid selected done-fn]
  (log/debug ">add-user " uuid selected)
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/web-user-selection/" uuid "/add-tom-ids")
                   (ajax/serialize selected)
                   (fn [r-list status]
                     (log/debug "drop-list done" r-list status)
                     (when (= status 200)
                       (done-fn)))))

(defn >remove-user [uuid selected done-fn]
  (log/debug ">remove-user " uuid selected)
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/web-user-selection/" uuid "/remove-tom-ids")
                   (ajax/serialize selected)
                   (fn [r-list status]
                     (log/debug "remove-user done" r-list status)
                     (when (= status 200)
                       (done-fn)))))


(defn empty-list [uuid done-fn]
  (log/debug ">empty-list " uuid)
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/web-user-selection/" uuid "/empty-tom-ids")
                   (ajax/serialize [])
                   (fn [r-list status]
                     (log/debug "empty-list done" r-list status)
                     (when (= status 200)
                       (done-fn)))))

(defn add-to-event-member [uuid event-uuid done-fn]
  (log/debug ">empty-list " uuid)
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/web-user-selection/" uuid "/add-to-event-member/" event-uuid)
                  (fn [r-list status]
                    (log/debug "add-to-event-member done" r-list status)
                    (when (= status 200)
                      (done-fn)))))

(defn add-to-training-member [uuid training-uuid done-fn]
  (log/debug ">empty-list " uuid)
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/web-user-selection/" uuid "/add-to-training-member/" training-uuid)
                  (fn [r-list status]
                    (log/debug "add-to-event-member done" r-list status)
                    (when (= status 200)
                      (done-fn)))))

(defn email-to-list [selection-uuid subject email from done-fn & [self]]
  (log/debug "email-to-list " selection-uuid)
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/web-user-selection/" selection-uuid "/send-email")
                   (ajax/serialize {:subject subject
                                    :message email
                                    :from    from
                                    :to-me   self})
                   (fn [r-list status]
                     (log/debug "email-to-list done" r-list status)
                     (when (= status 200)
                       (done-fn)))))

(defn sms-to-list [selection-uuid message done-fn]
  (log/debug "sms-to-list " selection-uuid)
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/web-user-selection/" selection-uuid "/send-sms")
                   (ajax/serialize {:message message})
                   (fn [r-list status]
                     (log/debug "sms-to-list done" r-list status)
                     (when (= status 200)
                       (done-fn)))))





